<footer *ngNativeAppConditionalVisibility aria-label="Main site footer, with legal links">
  <mat-toolbar class="primary-background justify-content-center footer-wrapper">
    <mat-toolbar-row>
      <div class="menu-list mb-4 mb-md-0">
        @for (item of menu; track item) {
          <a class="footer-link" [extendedRouterLink]="item.url || item.alias">
            {{item.title}}
          </a>
        }

        @for (item of documents; track item) {
          <a class="footer-link" [routerLink]="['/document', item.groupId]">
            {{item.title}}
          </a>
        }

        @if (email) {
          <a class="footer-link" [href]="'mailto:' + email">{{'FOOTER.contact_us' | translate }}</a>
        }

        <a class="footer-link" cookieConsentButton>
          {{'COOKIE_CONSENT.cookie_preferences' | translate }}
        </a>
      </div>
      <div class="social mt-sm-0">
        <div class="social-buttons-wrapper">
          @for (item of socialLinks; track item) {
            @if (item.url) {
              <a [attr.href]="item.url" mat-icon-button class="social-btn" target="_blank">
                <span class="social-icon">
                  @switch (item.id) {
                    @case (socialType.FACEBOOK) {
                      <img src="assets/images/facebook.svg" alt="Facebook">
                    }
                    @case (socialType.TWITTER) {
                      <img src="assets/images/twitter.svg" alt="X">
                    }
                    @case (socialType.YOUTUBE) {
                      <img src="assets/images/youtube.svg" alt="Youtube">
                    }
                    @case (socialType.INSTAGRAM) {
                      <img src="assets/images/instagram.svg" alt="Instagram">
                    }
                    @case (socialType.LINKEDIN) {
                      <img src="assets/images/linkedin.svg" alt="LinkedIn">
                    }
                    @case (socialType.WECHAT) {
                      <img src="assets/images/wechat.svg" alt="WeChat">
                    }
                  }
                </span>
              </a>
            }
          }
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</footer>
